module.exports = __webpack_public_path__ + "img/langostinos_al_ajillo.bb49c283.jpg";